<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="班级名称:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.className" auto-complete="off" class="formItem" size="small"
					maxLength="200" />
			</el-form-item>
			<el-form-item label="人数:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.personNum" auto-complete="off" class="formItem" size="small"
					maxLength="50" />
			</el-form-item>
			<!-- <el-form-item label="班级老师:" label-width="110px">
				<el-input v-model="addForm.teacherName" auto-complete="off" class="formItem" size="small"
					maxLength="50" />
			</el-form-item> -->
			<el-form-item label="联系电话:" label-width="110px">
				<el-input v-model="addForm.linkTel" auto-complete="off" class="formItem" size="small" maxLength="100" />
			</el-form-item>
			<el-form-item label="所属年级:" label-width="110px" class="notBlank">
				<el-select v-model="addForm.gradeId" placeholder="请选择" size="small" class="formItem250">
							<el-option v-for="item in gradeDict" :key="item.id" :label="item.gradeName"
								:value="item.id">
							</el-option>
						</el-select>
			</el-form-item>
			<el-form-item label="所属机构:" label-width="110px" class="notBlank">
					<el-select v-model="addForm.schoolId" placeholder="请选择" size="small" class="formItem" clearable>
						<el-option v-for="item in schoolDict" :key="item.id" :label="item.schoolName" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id: 0,
				classCode: '',
				className: '',
				personNum: '',
				teacherName: '',
				linkTel: '',
				gradeId: '',
				schoolId: '',
				addTime: '',
			},
			gradeDict:[],
			schoolDict:[],
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		async loadSchool() {
			let formData = this.$util.jsonToForm({
				schoolName: '',
				logName: '',
				linkTel: '',
				teamPerson: '',
				status: '',
				rows: 1000,
				page: 1
			});
			this.$axios.post("/school/getschoolinfolist", formData).then(res => {
				this.schoolDict = res.data.data;
			});
		},
		async loadGrade() {
			let formData = this.$util.jsonToForm({
				rows: 1000,
				page: 1
			});
			this.$axios.post("/basic/getgradeinfolist", formData).then(res => {
				this.gradeDict = res.data.data;
			});
		},
		initData() {
			this.$axios.get("/school/getclassinfoinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					if(this.addForm.id<=0){
						this.addForm.gradeId=''
						this.addForm.personNum=''
						this.addForm.schoolId=''
					}
				});
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/school/classinfosave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	},
	created(){
		this.loadSchool()
		this.loadGrade()
	}
};
</script>

<style lang="less" scoped></style>
